import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableData,
  TableBody,
} from '@welldev-group/rcl-table';
import { Toggle } from '@welldev-group/react-comp-lib';
import EntityManagementSection from './EntityManagementSection';

const ChannelManagementSection = ({
  className,
  channels,
  outOfLimit,
  limit,
  workspacesByID,
  setDeactivateChannelsIDs,
}) => {
  const handleToggleChange = channel => {
    setDeactivateChannelsIDs(prevState => {
      const newState = [...prevState];
      const channelId = channel.id;
      const newChannelState = !channel.active;
      const indexOfChannel = newState.indexOf(channelId);
      const storedInPrevState = indexOfChannel !== -1;

      if (!newChannelState && !storedInPrevState) {
        newState.push(channelId);

        return newState;
      }

      if (newChannelState && storedInPrevState) {
        newState.splice(indexOfChannel, 1);

        return newState;
      }

      return newState;
    });
  };

  return (
    <EntityManagementSection
      className={className}
      outOfLimit={outOfLimit}
      title={I18n.t('components.subscription.entity_section.title.channel')}
      limitText={I18n.t(
        'components.subscription.entity_section.limit_info.text.channel',
        {
          count: limit,
        },
      )}
      limitAlertText={I18n.t(
        'components.subscription.entity_section.limit_alert.channel',
      )}
      entityListTable={
        <Table
          className={classNames('entity-management-section__table', {
            'entity-management-section__table--warning-border': outOfLimit,
          })}
        >
          <TableHead>
            <TableRow>
              <TableHeader>
                {I18n.t(
                  'components.subscription.entity_section.table.header.channel_name',
                )}
              </TableHeader>
              <TableHeader>
                {I18n.t(
                  'components.subscription.entity_section.table.header.pcc_username',
                )}
              </TableHeader>
              <TableHeader>
                {I18n.t(
                  'components.subscription.entity_section.table.header.associated_workspaces',
                )}
              </TableHeader>
              <TableHeader />
            </TableRow>
          </TableHead>
          <TableBody>
            {channels.map(channel => (
              <TableRow key={channel.id}>
                <TableData>{channel.supplier}</TableData>
                <TableData>{channel.accountIdentifier}</TableData>
                <TableData>
                  {channel.workspaceIds
                    .map(workspaceID => workspacesByID[workspaceID])
                    .join(', ')}
                </TableData>
                <TableData
                  className="entity-management-section__table-toggle-wrapper"
                  align="right"
                >
                  <Toggle
                    isChecked={channel.active}
                    size="tiny"
                    disabled={!channel.changeable}
                    onChange={() => handleToggleChange(channel)}
                  />
                </TableData>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      }
    />
  );
};

ChannelManagementSection.defaultProps = {
  className: '',
  channels: [],
  limit: 0,
  outOfLimit: false,
  workspacesByID: {},
  setDeactivateChannelsIDs: () => {},
};

ChannelManagementSection.propTypes = {
  className: PropTypes.string,
  channels: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
      changeable: PropTypes.bool,
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      identifier: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
    }),
  ),
  limit: PropTypes.number,
  outOfLimit: PropTypes.bool,
  workspacesByID: PropTypes.shape({}),
  setDeactivateChannelsIDs: PropTypes.func,
};

export default ChannelManagementSection;
